import blankAction from '../assets/images/bbBlankAction.png'
import getAction from './getAction'
import getCombatantSlots from './getCombatantSlots'

export default async function getCombatantPreviousRoundActionImage(combatant, round) {
  console.log('------------------------------------------------')
  console.log('IN getCombatantPreviousRoundActionImage = ', {
    name: combatant?.name,
    slug: combatant?.slug,
    round,
  })

  if (!combatant?.slug || !Number.isFinite(round) || round <= 1) {
    console.log('getCombatantPreviousRoundActionImage early return due to invalid combatant/round')
    return ''
  }

  const slots = await getCombatantSlots(combatant.slug)
  const previousRound = round - 1
  const actions = Array.isArray(slots?.actions) ? slots.actions : []
  const allowedCA = Number(combatant?.ca)
  const hasAllowedCALimit = Number.isFinite(allowedCA) && allowedCA > 0

  const previousRoundAction = actions
    .filter(
      (action) =>
        action?.round === previousRound &&
        Number.isFinite(action?.number) &&
        (!hasAllowedCALimit || action.number <= allowedCA) &&
        action?.action_name !== 'pending' &&
        action?.action_name !== 'blank' &&
        getAction(action?.action_name)?.actual !== false,
    )
    .sort((left, right) => right.number - left.number)[0]

  console.log('getCombatantPreviousRoundActionImage action summary = ', {
    name: combatant?.name,
    previousRound,
    allowedCA: hasAllowedCALimit ? allowedCA : null,
    actionCount: actions.length,
    previousRoundActionCount: actions.filter((action) => action?.round === previousRound).length,
    selectedAction: previousRoundAction
      ? {
          action_name: previousRoundAction.action_name,
          number: previousRoundAction.number,
          action_image: previousRoundAction.action_image,
        }
      : null,
    fallbackImage: previousRoundAction?.action_image || blankAction,
  })

  return previousRoundAction?.action_image || blankAction
}
